import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is to track the Weekly stats details from the backend.
 */
export const WEEKLY_STATS_INFO_QUERY_KEY = 'weekly-stats-info-query';

/**
 * This hook fetches the Weekly stats details from APi.
 */
export const useWeeklyStatsInfoQuery = () => {
  const { data, error, isError, isFetching, isLoading, refetch } =
    useQueryWithUserId({
      queryKey: [WEEKLY_STATS_INFO_QUERY_KEY],
      networkMode: 'always',
      retry: false,
      queryFn: INV_MGMT_SERVICE_API.getWeeklyStatsInfo,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isLoading,
    refetch,
  };
};
